import React, { Component } from 'react';
import axios from 'axios'
import qs from 'querystring'
import styled from 'styled-components'
import { Flex, Box } from 'reflexbox'
import {
  getCookie,
  getExperimentationCookie
} from './scripts/common'
import {
  impressionsTracking,
  failureTracking,
  clickTracking
} from './scripts/tracking'
import noPhoto from './image/icon_no-photo_48x37.png';

const COOKIES = {
  LURKER_ID: 'l_id',
  TEST_ID: {
    GALLERY: 'TestAB_Track6'
  }
}

const BASE_URL_REC = 'https://recommendation.olx.com.br/api/rec'

const ImageBox = styled.div`
  background: #FFF;
  border: 1px solid #CCC;
  color: #666;
  display: table-cell;
  height: 86px;
  overflow: hidden;
  text-align: center;
  vertical-align: middle;
  width: 114px;

`
const ImageWrapper = styled.div`
  height: 88px;
  width: 114px;
`

const Image = styled.img`
  max-height: 86px;
  max-width: 114px;
  vertical-align: middle;
`

const Title = styled.h3`
  font-family: Nunito Sans, sans-serif;
  margin: 0;
  color: #38B;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.167em;
  max-height: 42px;
  overflow: hidden;
  width: 93%;
  padding-left: 7%;
`

const Price = styled.p`
  font-family: Nunito Sans, sans-serif;
  margin: 0;
  font-size: 13px;
  padding-left: 7%;
  font-weight: bold;
`

const Link = styled.a`
  height: 96px;
  padding: 5px;
  flex: 1 1 auto;
  display: flex;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    background-color: #e3edf6;
  }
`

const NoPhoto = styled.img`
  display: block;
  height: 37px;
  margin: 0 auto;
  overflow: hidden;
  text-indent: -999px;
  width: 48px;
}
`

const GalleryWrapper = ({ children }) => (
  <div>
    <div className="gallery-content">
       <div className="gallery-head">
           <span className="gallery-title">Galeria</span>
           <a href="javascript:void(0)" title="Sobre Galeria" className="more-info-gallery-link" rel=".module_lightbox.gallery" lurker="gallery_info">
               Colocar anúncio aqui
           </a>
       </div>
       {children}
    </div>
  </div>
)

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      recState: null,
      algorithm: '',
      algorithm_version: ''
    }
  }

  componentWillMount() {
    var checkExist = setInterval(() => {
      const dataLayer = window.dataLayer || []
      const template_vars = window.template_vars || []
      if (dataLayer.length) {
        const lurker_id = this.getLurkerId()
        const test_id = this.getTestId()
        const region_id = this.getRegionId(dataLayer[0])
        const subcategory_id = this.getSubcategoryId(dataLayer[0])
        const state_id = this.getStateId(dataLayer[0])
        const zone_id = this.getZoneId(dataLayer[0])
        const category_id = this.getParentCategoryId(dataLayer[0])
        const sd_id = Array.prototype.slice.apply(document.querySelectorAll("input[name=sd][type=hidden]")).map(function(item) {return item.value})
        const keyword_search = this.getKeywordSearch(template_vars)

        const galleryProperties = {
          lurker_id,
          test_id,
          region_id,
          subcategory_id,
          category_id,
          state_id,
          zone_id,
          sd_id,
          keyword_search
        }
        axios.get(`${BASE_URL_REC}/gallery?${qs.stringify(galleryProperties)}`)
          .then(({data}) => {
            if (data.content.length !== 0) {
              impressionsTracking("gallery", "listing-gallery-ads", data.algorithm, data.algorithm_version, data.content);
            }
            this.setState({
              recState: data.content,
              algorithm: data.algorithm,
              algorithm_version: data.algorithm_version
            })
          })
          .catch(error => {
            if (error.response) {
              failureTracking("gallery", JSON.stringify(error.response.status))
            }
          })
        clearInterval(checkExist);
      }
    }, 200)
  }

  getLurkerId = () => getCookie(COOKIES.LURKER_ID)
  getTestId = () => getExperimentationCookie(COOKIES.TEST_ID.GALLERY)
  getRegionId = obj => this.getValueFromNestedObject(['page', 'detail', 'region_id'], obj)
  getStateId = obj => this.getValueFromNestedObject(['page', 'detail', 'state_id'], obj)
  getSubcategoryId = obj => this.getValueFromNestedObject(['page', 'detail', 'category_id'], obj)
  getParentCategoryId = obj => this.getValueFromNestedObject(['page', 'detail', 'parent_category_id'], obj)
  getZoneId = obj => this.getValueFromNestedObject(['page', 'searchDetail', 'subRegionID'], obj)
  getKeywordSearch = obj => this.getValueFromNestedObject(['q'], obj)

  getValueFromNestedObject = (s, o) =>
    s.reduce((prev, cur) => ((prev && prev[cur]) ? prev[cur] : null), o)

  handleClick(ad, adPosition) {
    clickTracking('gallery', this.state.algorithm, this.state.algorithm_version, ad.list_id, adPosition);
  }

  onImgError(e, noPhoto) {
    if (e.target.src !== noPhoto) {
      e.target.src = noPhoto;
    }
    return true;
  }

  render() {
    if(!this.state.recState || Object.keys(this.state.recState).length === 0) return false
    return (
      <GalleryWrapper>
        <Flex p={0} align='center' style={{ maxWidth: '728px', padding: '10px 0 10px 0'}}>
            {this.state.recState.map((ad, i) => {
              return (
                <Box w={1/3} style={{overflow: 'hidden' }} auto flex key={i} alt={ad.subject}>
                  <Link href={ad.ad_url} onClick={() => this.handleClick(ad, i)}>
                    <Box w={1/2}>
                      <ImageWrapper>
                        <ImageBox>
                          {(ad.image_url)?
                            <Image className="image" src={ad.image_url} onError={(e) => this.onImgError(e, noPhoto)} />
                            :
                            <NoPhoto src={noPhoto}></NoPhoto>
                          }
                        </ImageBox>
                      </ImageWrapper>
                    </Box>
                    <Box w={1/2} style={{paddingRight: '10px'}}>
                      <Title>{ad.subject}</Title>
                      <Price>{ad.price}</Price>
                    </Box>
                  </Link>
                </Box>
              )
            })}
        </Flex>
      </GalleryWrapper>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js